module.exports = __webpack_public_path__ + "static/media/sk_swiper_x.f41accd8.jpg";